import {BaseLoadingStore} from "app/modules/common/stores/BaseLoadingStore";
import {inject} from "react-ioc";
import {ApiClients} from "app/modules/main/services/AxiosBaseClient";
import {FieldState, FormState} from "formstate";
import {required} from "app/modules/common/form/validators";
import {action, makeObservable, observable, runInAction} from "mobx";
import {PropertyAmenityEditModel, PropertyAmenityModel} from "app/modules/main/api/admin-clients.api";

export class DetailsStore extends BaseLoadingStore {
    @inject apiClients: ApiClients;

    propertyAmenityId: number = null;
    name: string = null;

    formState = new FormState({
        name: new FieldState('').validators(required),
        active: new FieldState<boolean>(true),
    });

    constructor() {
        super();

        makeObservable(this, {
            propertyAmenityId: observable,
            name: observable,

            save: action
        });
    }

    save = async () => {
        await this.formState.validate();

        if (this.formState.hasError) {
            return;
        }

        await this.wrapLoadingApiCall(async () => {
            let model = new PropertyAmenityEditModel({
                name: this.formState.$.name.value,
                id: this.propertyAmenityId,
                active: this.formState.$.active.value
            });

            if(this.propertyAmenityId > 0) {
                await this.apiClients.propertyAmenityClient.upsertPropertyAmenity(model);
            } else {
                this.propertyAmenityId = await this.apiClients.propertyAmenityClient.upsertPropertyAmenity(model);

                runInAction(() => {
                    this.isSavedSuccessfully = true;
                });
            }
        });
    }

    init = async (id?: number) => {
        this.propertyAmenityId = id;

        await this.wrapInitLoadingApiCall(async () => {
            if(this.propertyAmenityId > 0) {
                let result : PropertyAmenityModel = await this.apiClients.propertyAmenityClient.getDetails(this.propertyAmenityId);

                runInAction(() => {
                    this.name = result.name;

                    this.formState.$.name.value = result.name;
                    this.formState.$.active.value = result.active;
                });
            }
        });
    }
}
